var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "#F5C300",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16882_951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58341 8.37506H6.20841V14.8751H4.58341C4.43976 14.8751 4.30198 14.818 4.2004 14.7164C4.09882 14.6148 4.04175 14.4771 4.04175 14.3334V8.91673C4.04175 8.77307 4.09882 8.63529 4.2004 8.53371C4.30198 8.43213 4.43976 8.37506 4.58341 8.37506ZM7.45046 7.67469L10.9171 4.20802C10.9632 4.16181 11.0244 4.13379 11.0895 4.12912C11.1546 4.12444 11.2192 4.14342 11.2714 4.18256L11.7334 4.52923C11.8617 4.62556 11.9587 4.75773 12.012 4.90907C12.0653 5.06042 12.0726 5.22416 12.033 5.37964L11.4084 7.83339H14.8751C15.1624 7.83339 15.4379 7.94753 15.6411 8.1507C15.8443 8.35386 15.9584 8.62941 15.9584 8.91673V10.0564C15.9586 10.198 15.931 10.3382 15.8772 10.4691L14.2007 14.5398C14.1598 14.639 14.0904 14.7239 14.0011 14.7836C13.9119 14.8433 13.807 14.8751 13.6997 14.8751H7.83341C7.68976 14.8751 7.55198 14.818 7.4504 14.7164C7.34882 14.6148 7.29175 14.4771 7.29175 14.3334V8.05764C7.29178 7.914 7.34887 7.77624 7.45046 7.67469Z",
    fill: "#F5C300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16882_951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(3.5 3.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertMedium);
export default __webpack_public_path__ + "static/media/alert-medium.ea7a4b1b19e58faf4b5a8ccb648d9685.svg";
export { ForwardRef as ReactComponent };